import { create } from 'zustand';

type JobEvent = {
  message: string;
  stage?: string;
  data?: Record<string, any> | null;
  at?: string;
  eventType?: string;
};

type PartialWidget = {
  id?: string;
  title?: string;
  type?: string;
};

type JobState = {
  jobId: string | null;
  status: string | null;
  events: JobEvent[];
  widgets: PartialWidget[];
  dashboardId: string | null;
  message: string | null;
  error: string | null;
  result: any;
  startJob: (jobId: string) => void;
  resetJob: () => void;
  applyProgress: (payload: { event?: JobEvent; status?: string; result?: any }) => void;
  applyWidget: (widget: PartialWidget) => void;
  markDone: (payload: { result?: any }) => void;
  markFailed: (payload: { error?: string }) => void;
};

const INITIAL_JOB_ID = sessionStorage.getItem('activeDashboardJob');

export const useDashboardJobStore = create<JobState>((set) => ({
  jobId: INITIAL_JOB_ID,
  status: null,
  events: [],
  widgets: [],
  dashboardId: null,
  message: null,
  error: null,
  result: null,
  startJob: (jobId) => {
    sessionStorage.setItem('activeDashboardJob', jobId);
    set({
      jobId,
      status: 'RUNNING',
      events: [],
      widgets: [],
      dashboardId: null,
      message: 'Job iniciado',
      error: null,
      result: null,
    });
  },
  resetJob: () => {
    sessionStorage.removeItem('activeDashboardJob');
    set({
      jobId: null,
      status: null,
      events: [],
      widgets: [],
      dashboardId: null,
      message: null,
      error: null,
      result: null,
    });
  },
  applyProgress: ({ event, status, result }) =>
    set((state) => {
      const nextEvents = event ? [...state.events, event] : state.events;
      const nextResult = result ?? state.result;
      const nextDashboardId =
        nextResult?.dashboard?.id || nextResult?.dashboardId || state.dashboardId;
      return {
        events: nextEvents,
        status: status || state.status,
        message: event?.message || state.message,
        result: nextResult,
        dashboardId: nextDashboardId,
      };
    }),
  applyWidget: (widget) =>
    set((state) => {
      if (!widget?.title && !widget?.id) return state;
      const exists = state.widgets.some(
        (item) => item.id && widget.id && item.id === widget.id
      );
      if (exists) return state;
      return { widgets: [...state.widgets, widget] };
    }),
  markDone: ({ result }) =>
    set((state) => ({
      status: 'DONE',
      result: result ?? state.result,
      dashboardId: result?.dashboard?.id || state.dashboardId,
      message: 'Job finalizado',
    })),
  markFailed: ({ error }) =>
    set((state) => ({
      status: 'FAILED',
      error: error || state.error || 'Error en job',
    })),
}));
